import { render, staticRenderFns } from "./UIAlert.vue?vue&type=template&id=442f5f74"
import script from "./UIAlert.vue?vue&type=script&lang=js"
export * from "./UIAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports